/**
 * Unica puerta de entrada de iconografia. El resto del codigo importa conceptos
 * del dominio, no nombres de Heroicons, para que cambiar de libreria sea tocar
 * un solo fichero. No se usan emojis en ninguna parte de la interfaz: se ven
 * distintos en cada sistema operativo y no se pueden tenir con el tema.
 */
export {
  TruckIcon as IconoLogistica,
  ChatBubbleLeftRightIcon as IconoConversaciones,
  UserPlusIcon as IconoLeads,
  MegaphoneIcon as IconoAvisos,
  CalendarDaysIcon as IconoAgendamiento,
  CalendarIcon as IconoCalendario,
  MagnifyingGlassIcon as IconoBuscar,
  MapPinIcon as IconoUbicacion,
  ArrowsPointingOutIcon as IconoAmpliar,
  PhoneIcon as IconoTelefono,
  DocumentTextIcon as IconoFactura,
  EnvelopeIcon as IconoCorreo,
  ArrowPathIcon as IconoActualizar,
  ArrowRightStartOnRectangleIcon as IconoSalir,
  UserCircleIcon as IconoCliente,
  XMarkIcon as IconoCerrar,
  ChevronLeftIcon as IconoVolver,
  ChartBarIcon as IconoGrafica,
  ExclamationTriangleIcon as IconoAviso,
  InboxIcon as IconoVacio,
  CheckCircleIcon as IconoCorrecto,
  ClockIcon as IconoPendiente,
  QuestionMarkCircleIcon as IconoDuda,
  PlusIcon as IconoAnadir,
  TrashIcon as IconoQuitar,
  ChevronDownIcon as IconoDesplegar,
  ClipboardDocumentIcon as IconoCopiar,
  TableCellsIcon as IconoHoja,
  CpuChipIcon as IconoWorkflows,
  ClipboardDocumentCheckIcon as IconoConfirmar,
  ArrowPathRoundedSquareIcon as IconoRecalculo,
  ExclamationTriangleIcon as IconoIncidencias,
  ClipboardDocumentListIcon as IconoAuditoria,
  BuildingOffice2Icon as IconoGE,
  EllipsisHorizontalIcon as IconoMas,
  BellIcon as IconoCampana,
  BellAlertIcon as IconoCampanaAlerta,
  ClockIcon as IconoReloj,
  PaperAirplaneIcon as IconoEnviar,
  PauseCircleIcon as IconoPausa,
  PlayCircleIcon as IconoReanudar,
} from '@heroicons/react/24/outline'

export {
  TruckIcon as IconoLogisticaSolido,
  ChatBubbleLeftRightIcon as IconoConversacionesSolido,
  UserPlusIcon as IconoLeadsSolido,
  MegaphoneIcon as IconoAvisosSolido,
  CalendarDaysIcon as IconoAgendamientoSolido,
  CalendarIcon as IconoCalendarioSolido,
  CpuChipIcon as IconoWorkflowsSolido,
  ClipboardDocumentCheckIcon as IconoConfirmarSolido,
  ArrowPathRoundedSquareIcon as IconoRecalculoSolido,
  ExclamationTriangleIcon as IconoIncidenciasSolido,
  ClipboardDocumentListIcon as IconoAuditoriaSolido,
  BuildingOffice2Icon as IconoGESolido,
} from '@heroicons/react/24/solid'

/**
 * Logo de WhatsApp. Heroicons no incluye marcas, así que es un SVG propio (path
 * oficial del glifo de WhatsApp). Hereda el color con `currentColor` y el tamaño
 * por la clase, como el resto de iconos. No es emoji: se tiñe con el tema.
 */
export function IconoWhatsapp({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden className={className}>
      <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.82 9.82 0 001.5 5.26l-.999 3.648 3.998-1.607zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
    </svg>
  )
}
